<template>
    <sidebar
        :id="id"
        class="cookie-preferences"
        title="Preferencias de almacenamiento"
        :show="showCookiePreferences"
        @afterClose="closeCookiePreferences"
    >
        <form @submit.prevent="saveCookiePreferences">
            <ul>
                <li v-if="!isCookiePreferenceDisabled('essentials')" class="preference">
                    <p class="preference-header">
                        <span>
                            Esenciales
                        </span>
                        <label class="switch">
                            <input
                                v-model="cookiePreferences.essentials"
                                class="switch form-check-input"
                                type="checkbox"
                                name="defaultCardSelection"
                            />
                            <span class="slider round"></span>
                        </label>
                    </p>
                    <p>
                        Estas cookies son necesarias para el funcionamiento básico del sitio web.
                    </p>
                </li>
                <li v-if="!isCookiePreferenceDisabled('analytics')" class="preference">
                    <p class="preference-header">
                        <span>
                            Analítica
                        </span>
                        <label class="switch">
                            <input
                                v-model="cookiePreferences.analytics"
                                class="switch form-check-input"
                                type="checkbox"
                                name="defaultCardSelection"
                            />
                            <span class="slider round"></span>
                        </label>
                    </p>
                    <p>
                        Estas cookies ayudan al operador del sitio web a comprender cómo funciona su
                        sitio web, cómo interactúan los visitantes con el sitio y si existen
                        problemas técnicos. Este tipo de almacenamiento generalmente no recopila
                        información que identifique a un visitante.
                    </p>
                </li>
            </ul>
            <button type="submit" class="btn btn-primary">Guardar cambios</button>
        </form>
    </sidebar>
</template>

<script>
export default {
    data: () => ({
        cookiePreferences: {
            essentials: true,
            analytics: true,
        },
        cookies: {
            // Agrupa las cookies existentes por categorias
            essentials: [
                'XSRF-TOKEN',
                'NID',
                'AID',
                'CM14',
                'CONSENT',
                'CM',
                'C',
                'uid',
                'laravel_session',
                'TawkConnectionTime',
                '__tawkuuid',
                'SWSLOCAL',
                'tawkUUID'
            ],
            analytics: [
                // https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage?hl=es-419
                '_gcl_au',
                '_gid',
                '_ga',
                '_gac_gb',
            ],
        },
    }),
    props: {
        id: {
            type: String,
            required: true,
        },
        showCookiePreferences: {
            type: Boolean,
            required: true,
        },
        disabledCookiePreferences: {
            type: Array,
            required: false,
            default: () => ([])
        },
    },
    computed: {
        enabledCookiePreferences() {
            const cookiePreferencesKeys = Object.keys(this.cookiePreferences).filter(
                cookiePreferenceKey => !this.isCookiePreferenceDisabled(cookiePreferenceKey),
            );
            const enabledCookiePreferences = {}
            cookiePreferencesKeys.forEach(cookiePreferenceKey => enabledCookiePreferences[cookiePreferenceKey] = this.cookiePreferences[cookiePreferenceKey])
            return enabledCookiePreferences
        },
    },
    methods: {
        isCookiePreferenceDisabled(cookiePreference) {
            return this.disabledCookiePreferences.includes(cookiePreference);
        },
        closeCookiePreferences() {
            this.$emit('close');
        },
        saveCookiePreferences() {
            const cookiesJson = JSON.stringify(this.cookiePreferences);
            localStorage.cookiesPreferences = cookiesJson;
            Object.keys(this.enabledCookiePreferences).map(cookieKey =>
                this.cookiePreferences[cookieKey] ? null : this.removeCookies(cookieKey),
            );
            this.$emit('submit');
        },
        removeCookies(cookieKeyToRemove) {
            const cookiesToRemove = this.cookies[cookieKeyToRemove];
            const cookieKeysToRemove = this.$cookies.keys().filter(
                cookieKey =>
                    cookiesToRemove
                        .map(cookieKeyToRemove => cookieKey.includes(cookieKeyToRemove))
                        .some(a => !!a), // retornar true si al menos alguno es true,
            );
            cookieKeysToRemove.forEach(cookieKeyToRemove =>
                this.$cookies.remove(cookieKeyToRemove),
            );
        },
    },
    mounted() {
        if (localStorage.cookiesPreferences) {
            setInterval(() => {
                this.cookiePreferences = JSON.parse(localStorage.cookiesPreferences);
                this.saveCookiePreferences();
            }, 10000);
        }
    },
};
</script>
